import { Box, VStack } from '@chakra-ui/react'
import { ChatContextProvider } from '@src/components/sco/Chat/ChatContext'
import { RequestsLayout } from '@src/components/sco/Requests/Layout/RequestsLayout'
import { RequestsMainPanelMobileToolbar } from '@src/components/sco/Requests/Layout/RequestsMainPanelMobileToolbar'
import { RequestDiscussionPanel } from '@src/components/sco/Requests/RequestDiscussionPanel'
import { RequestProfile } from '@src/components/sco/Requests/RequestProfile'
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider'
import { useParams } from 'next/navigation'

export default function Page() {
  const { getBreakpointValue } = useBreakpointContext()
  const params = useParams()

  return (
    <RequestsLayout
      groupRequestId={params.groupRequestId?.toString()}
      asidePanel={
        <ChatContextProvider>
          <RequestDiscussionPanel groupRequestId={params.groupRequestId?.toString()} />
        </ChatContextProvider>
      }
      mainPanel={
        <Box width={'full'}>
          <RequestsMainPanelMobileToolbar />
          <VStack
            align={'center'}
            padding={getBreakpointValue([2, 2, 2, 2, 4, 8])}
            paddingTop={0}
            width={'full'}
          >
            <Box maxWidth={'container.lg'} width={'full'}>
              <RequestProfile groupRequestId={params.groupRequestId?.toString()} />
            </Box>
          </VStack>
        </Box>
      }
    />
  )
}
